import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Component from "../../../domains/Component";

import { SLICE_NAME } from "./types";

interface ComponentsListingState {
  components: Array<Component>
  areComponentsLoading: boolean
  hasErrorLoadingComponents: boolean
}

const initialState: ComponentsListingState = {
  components: [],
  areComponentsLoading: false,
  hasErrorLoadingComponents: false,
};

export const componentsListingSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getComponents: state => {
      state.areComponentsLoading = true;
    },
    getComponentsSuccess: (
      state,
      action: PayloadAction<{
        components: Array<Component>
      }>,
    ) => {
      state.areComponentsLoading = false;
      state.components = action.payload.components;
    },
    getComponentsError: state => {
      state.areComponentsLoading = false;
      state.hasErrorLoadingComponents = true;
    },
    setComponents: (
      state,
      action: PayloadAction<{ components: Array<Component> }>,
    ) => {
      state.components = action.payload.components;
    },
  },
});

export const {
  getComponents,
  getComponentsSuccess,
  getComponentsError,
  setComponents,
} = componentsListingSlice.actions;

export default componentsListingSlice.reducer;
